module.exports = __webpack_public_path__ + "img/collection-diamondJewelry025Carat@2x.9c2099c.webp";